const configAttr = {
    cursorPointer: {
        cursor: 'pointer'
    },
    lineStrokeColorDark: {
        stroke: '#ADD8E6'
    },
    lineStrokeColorDarkLight: {
        stroke: '#04112F'
    },
    lineStrokeColorDisable: {
        stroke: '#9E9E9E'
    },
    lineStrokeColorDisableLight: {
        stroke: '#808080'
    },
    lineStrokeColorGreen: {
        stroke: '#3CB371'
    },
    lineStrokeColorLight: {
        stroke: '#000000'
    },
    lineRectStrokeColorPurple: {
        stroke: '#cc99ff',
        'stroke-dasharray': '--'
    },
    lineRectStrokeColorPurpleLight: {
        stroke: '#b061ff',
        'stroke-dasharray': '--'
    },
    dash_rect: {
        stroke: '#ADD8E6',
        'stroke-dasharray': '--'
    },
    dash_rectLight: {
        stroke: '#04112F',
        'stroke-dasharray': '--'
    },
    dash_disable_rect: {
        stroke: '#9E9E9E',
        'stroke-dasharray': '--'
    },
    dash_disable_rectLight: {
        stroke: '#808080',
        'stroke-dasharray': '--'
    },
    dash_disable_rect_orange: {
        stroke: '#ff9900',
        'stroke-dasharray': '--'
    },
    block_headertext: {
        'fill': '#FF7043',
        'font-size': '16px',
        'font-weight': 'bold'
    },
    block_subHeaderText: {
        'fill': '#FF7043',
        'font-size': '12px',
        'font-weight': 'bold'
    },
    gridLine_text: {
        'fill': '#ADD8E6',
        'font-size': '16px',
        'font-weight': 'bold'
    },
    gridLine_textLight: {
        'fill': '#04112F',
        'font-size': '16px',
        'font-weight': 'bold'
    },
    header_text: {
        'fill': '#ADD8E6',
        'font-size': '12px',
        'font-weight': 'bold'
    },
    header_textLight: {
        'fill': '#04112F',
        'font-size': '12px',
        'font-weight': 'bold'
    },
    block_text: {
        'fill': '#ADD8E6',
        'font-size': '16px',
        'font-weight': 'bold'
    },
    block_textLight: {
        'fill': '#04112F',
        'font-size': '16px',
        'font-weight': 'bold'
    },
    info_text: {
        fill: '#ADD8E6',
        'font-size': '8px'
    },
    info_textLight: {
        fill: '#04112F',
        'font-size': '8px'
    },
    conn_text: {
        fill: '#ADD8E6',
        'font-size': '11px',
        'font-weight': 'bold'
    },
    conn_textLight: {
        fill: '#04112F',
        'font-size': '11px',
        'font-weight': 'bold'
    },
    side_text: {
        'fill': "#ADD8E6",
        'font-size': "16px",
        'font-weight': 'bold'
    },
    side_textLight: {
        'fill': "#04112F",
        'font-size': "16px",
        'font-weight': 'bold'
    },
    text_link: {
        'fill': "#ADD8E6",
        'font-size': "16px",
        'font-weight': 'bold',
        cursor: 'pointer'
    },
    text_linkLight: {
        'fill': "#04112F",
        'font-size': "16px",
        'font-weight': 'bold',
        cursor: 'pointer'
    }

}
export default configAttr